/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import Backend from "i18next-http-backend";
import format from "./format";
import { languages } from "./languages";
import getLoadPath from "./loadPath";

i18n.use(initReactI18next)
    .use(Backend)
    .init({
        backend: {
            loadPath: getLoadPath,
        },
        load: "languageOnly",
        lng: window.navigator.language,
        fallbackLng: languages.en,
        react: {
            useSuspense: true,
        },
        ns: ["i18nBasis", "i18nDomainDrivenDesign"],
        defaultNS: "i18nBasis",
        fallbackNS: "i18nBasis",
        interpolation: {
            escapeValue: false,
            format
        },
        // siehe https://www.i18next.com/misc/migration-guide#json-format-v4-pluralization
        compatibilityJSON: "v3",
    });

export default i18n;
